__turbopack_context__.v({
  "chartImg": "_2l0M-G_chartImg",
  "imgDesktop": "_2l0M-G_imgDesktop",
  "imgMobile": "_2l0M-G_imgMobile",
  "root": "_2l0M-G_root",
  "stickyWrapper": "_2l0M-G_stickyWrapper",
  "textContent": "_2l0M-G_textContent",
});
